<template>
  <div v-if="inventoryType" class="row">
    <div class="col-md-12" v-for="rPlan in ratePlans" v-bind:key="rPlan.id">
      <div class="card rate" :class="{'selected': ratePlan === rPlan.id}">
        <div>
          <div class="card-header">
            <h3 class="card-title pull-right">
              {{ rPlan.amount }}₽
            </h3>
            <h3 class="category cart-category text-info pull-left">{{ rPlan.name }}</h3>
          </div>
          <div class="card-content">
            <ul v-if="rPlan.description" class="pull-left">
              <span v-html="rPlan.description"></span>
            </ul>
            <div>
              <a
                @click="selectRatePlan(rPlan.id)"
                class="btn btn-rose btn-round pull-right"
              >{{ ratePlan === rPlan.id ? 'Выбрано' : 'Выбрать' }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'RatePlanSelect',
  props: [
    'inventoryType',
    'dateRange',
    'inventoryBlock',
    'guestCount',
  ],
  data() {
    return {
      ratePlans: null, // List of rateplans for the selected inventory blocks, date period and guests
      ratePlan: null, // the current selected rate plan
      roomRates: null,
    };
  },
  computed: {
    ...mapGetters(
      {
        rates: 'rates',
      },
    ),
    totalAmount: {
      get() {
        if (this.roomRates) {
          let sum = 0;
          this.roomRates.forEach((item) => {
            sum += item.price;
          });
          return sum;
        }
        return null;
      },
    },
  },
  mounted() {
    this.updatePrice();
  },
  methods: {
    createRatePlanDays() {
      this.roomRates = [];
      const prices = this.ratePlanPrices.find(p => p.rate_plan === this.ratePlan).prices.find(p => p.inventory_type === this.inventoryType).prices;
      for (const price of prices) {
        this.roomRates.push({
          date: price.date,
          rate_plan: this.ratePlan,
          price: price.price,
        });
      }
    },
    selectRatePlan(id) {
      if (id && this.ratePlans.find(p => p.id === id).amount) {
        this.ratePlan = id;
        this.createRatePlanDays();
        this.mutateReservation(false);
      } else {
        this.ratePlan = null;
        this.roomRates = null;
      }
    },
    updateRatePlans(ratePlanPrices) {
      const plans = [];
      for (const ratePlan of ratePlanPrices) {
        const prices = ratePlan.prices.find(p => p.inventory_type === this.inventoryType);
        if (prices && prices.prices) {
          const amount = this.sumPrice(prices.prices);
          if (amount != null) {
            plans.push(
              {
                id: ratePlan.rate_plan,
                name: this.rates.find(p => p.id === ratePlan.rate_plan).name,
                amount,
                description: this.rates.find(p => p.id === ratePlan.rate_plan).description,
              },
            );
          }
        }
      }
      this.ratePlans = plans;
    },
    updatePrice() {
      if (this.inventoryBlock && this.inventoryType && this.dateRange && this.guestCount) {
        axios.post('/api/rate-prices/',
          {
            date_from: this.dateRange.date_from,
            date_to: moment(this.dateRange.date_to).format('YYYY-MM-DD'),
            inventory_block: this.inventoryBlock,
            guests: this.guestCount,
          }).then((response) => {
          this.ratePlanPrices = response.data.rate_plan_prices;
          this.updateRatePlans(this.ratePlanPrices);
          this.selectRatePlan(this.ratePlan);
        });
      } else {
        this.selectRatePlan(null);
      }
    },
    sumPrice(prices) {
      if (prices) {
        let total = 0;
        for (const item of prices) {
          if (item.price === null) {
            return null;
          }
          total += item.price;
        }
        return total;
      }
      return null;
    },
    ratePrices(ratePlan) {
      if (this.ratePlanPrices) {
        const rp = this.ratePlanPrices.find(p => p.rate_plan === ratePlan);
        if (rp === null) {
          return null;
        }

        const prices = rp.prices.find(p => p.inventory_type === this.inventoryType);
        if (prices === null) {
          return null;
        }

        return prices.prices;
      }
      return null;
    },
    ...mapMutations(['mutateReservation']),
  },
  watch: {
    ratePlan() {
      this.$emit('ratePlanChanged', this.ratePlan);
    },
    roomRates() {
      this.$emit('roomRatesChanged', this.roomRates);
    },
    totalAmount() {
      this.$emit('totalAmountChanged', this.ratePlan ? this.ratePlans.find(p => p.id === this.ratePlan).amount : null);
    },
    inventoryType() {
      this.updatePrice();
    },
    dateRange() {
      this.updatePrice();
    },
    inventoryBlock() {
      this.updatePrice();
      this.selectRatePlan(null);
    },
    guestCount() {
      this.updatePrice();
    },
  },
};
</script>

<style lang="sass" scoped>
  .card.active
    background: rgba(198, 255, 226, 0.48)

  .card-content
    clear: both
    float: none

  .card-title
    margin-right: 20px

  .cart-category
    margin-left: 20px

  .rate
    padding: 2px
    border: 1px solid #EEE
  .selected
    box-shadow: none
    padding: 0
    border: 3px solid #e91e6380
</style>
